import React from 'react';

export const AddToQueue = () => (
  <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
    <path
      fill="currentColor"
      d="M0 88C0 74.8 10.8 64 24 64c133.4 0 266.7 0 400 0c13.3 0 24 10.8 24 24c0 13.3-10.7 24-24 24c-133.4 0-266.7 0-400 0C10.8 112 0 101.3 0 88zM0 248c0-13.3 10.8-24 24-24c90.7 0 181.3 0 272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-90.7 0-181.3 0-272 0c-13.3 0-24-10.7-24-24zM168 432L24 432c-13.3 0-24-10.7-24-24s10.8-24 24-24c48 0 96 0 144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm472-64c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM480 304l0 48c-16 0-32 0-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c16 0 32 0 48 0l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-16 0-32 0-48c16 0 32 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c-16 0-32 0-48 0c0-16 0-32 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    />
  </svg>
);
